import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

class MMPLShortClosed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { totalRecords, pageSize } = this.props;
    return (
      <div className="pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">
                  {this.renderCardPendingData()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {totalRecords !== 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  No PO's
              </h6>
              </div>
            </div>
          )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }

  renderCardPendingData = () => {
    const { arraylist, undoShortClosed } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
            <div className="px-3 py-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                    <div className="row">
                      <div className="col-sm-3 col-md-3">
                        <h6 className="resource-list-title mb-0" style={{ cursor: "pointer" }}>
                          {item ? item.poNo : ""}
                        </h6>
                      </div>
                      <div className="col-sm-3 col-md-3">
                        <span>
                          <strong>PO Date : </strong>
                          <span className="italicFont">{item ? Moment(new Date(Date.parse(item.poDate))).format('DD MMM YYYY') : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-3 col-md-3">
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont ">{item ? item.vesselName : ""}</span>
                        </span>
                      </div>
                      {/* <div className="col-sm-3 col-md-3">
                        <span>
                          <strong>Last reviewed : </strong>
                          <span className="italicFont ">{item ? Moment(new Date(Date.parse(item.lastReviewed))).format('DD MMM YYYY') : ""}</span>
                        </span>
                      </div> */}
                    </div>
                  </div>

                  <div className="col-sm-2 col-md-1 col-2 col-m-auto text-center">
                    {/* {item.isValidated ? */}
                    {/* <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.updatePopover()} >
                      <i className="fa fa-undo click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }}
                        onClick={() => undoShortClosed(item)}
                      >
                      </i>
                    </OverlayTrigger> */}
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.updatePopover()} >
                      <i className="fa fa-edit click text-right" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }} onClick={() => this.showEditShortCloseDetailPanel(item.shipId, item.purchaseOrderId)}>
                      </i>
                    </OverlayTrigger>
                    {/* : null} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }) : null;
  };

  showEditShortCloseDetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: 'getPOLineItemsSuccess', data: null });
    dispatch({ type: "EditPOView", data: true });
    history.push(`/Home/ShortClose/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };


}

function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLShortClosed)
);
